// extracted by mini-css-extract-plugin
export default {"layout":"Character_layout__czd31","image":"Character_image__rMT8d"};